import { WorkLogsQueryParams } from '@adminServices';
import { AdminCreateWorkLogDto, ApproveWorkLogDto, RejectWorkLogDto, UpdateWorkLogDto, WorkLog } from '@klubovna/api-client';
import { createAction, props } from '@ngrx/store';
import { PaginationMetadata } from '@shared';

export const ADMIN_WORK_LOGS_ID = '[WorkLogs admin]';

export const loadWorkLogs = createAction(
  ADMIN_WORK_LOGS_ID + ' Load WorkLogs',
  props<{ params?: WorkLogsQueryParams }>(),
);

export const loadWorkLogsSuccess = createAction(
  ADMIN_WORK_LOGS_ID + ' Load WorkLogs Success',
  props<{ workLogs: WorkLog[]; pagination: PaginationMetadata }>(),
);

export const loadWorkLogsFailure = createAction(
  ADMIN_WORK_LOGS_ID + ' Load WorkLogs Failure',
  props<{ error: string }>(),
);

export const adminCreateWorkLog = createAction(
  ADMIN_WORK_LOGS_ID + ' Admin Create WorkLog',
  props<{ workLogData: AdminCreateWorkLogDto }>(),
);

export const adminCreateWorkLogSuccess = createAction(
  ADMIN_WORK_LOGS_ID + ' Admin Create WorkLog Success',
  props<{ workLog: WorkLog }>(),
);

export const adminCreateWorkLogFailure = createAction(
  ADMIN_WORK_LOGS_ID + ' Admin Create WorkLog Failure',
  props<{ error: string }>(),
);

export const approveWorkLog = createAction(
  ADMIN_WORK_LOGS_ID + ' Approve WorkLog',
  props<{ id: string; approveData: ApproveWorkLogDto }>(),
);

export const approveWorkLogSuccess = createAction(
  ADMIN_WORK_LOGS_ID + ' Approve WorkLog Success',
  props<{ workLog: WorkLog }>(),
);

export const approveWorkLogFailure = createAction(
  ADMIN_WORK_LOGS_ID + ' Approve WorkLog Failure',
  props<{ error: string }>(),
);

export const rejectWorkLog = createAction(
  ADMIN_WORK_LOGS_ID + ' Reject WorkLog',
  props<{ id: string; rejectData: RejectWorkLogDto }>(),
);

export const rejectWorkLogSuccess = createAction(
  ADMIN_WORK_LOGS_ID + ' Reject WorkLog Success',
  props<{ workLog: WorkLog }>(),
);

export const rejectWorkLogFailure = createAction(
  ADMIN_WORK_LOGS_ID + ' Reject WorkLog Failure',
  props<{ error: string }>(),
);

export const updateWorkLog = createAction(
  ADMIN_WORK_LOGS_ID + ' Update WorkLog',
  props<{ id: string; updateData: UpdateWorkLogDto }>(),
);

export const updateWorkLogSuccess = createAction(
  ADMIN_WORK_LOGS_ID + ' Update WorkLog Success',
  props<{ workLog: WorkLog }>(),
);

export const updateWorkLogFailure = createAction(
  ADMIN_WORK_LOGS_ID + ' Update WorkLog Failure',
  props<{ error: string }>(),
);

export const deleteWorkLog = createAction(
  ADMIN_WORK_LOGS_ID + ' Delete WorkLog',
  props<{ id: string }>(),
);

export const deleteWorkLogSuccess = createAction(
  ADMIN_WORK_LOGS_ID + ' Delete WorkLog Success',
  props<{ id: string }>(),
);

export const deleteWorkLogFailure = createAction(
  ADMIN_WORK_LOGS_ID + ' Delete WorkLog Failure',
  props<{ error: string }>(),
);
